import { t, Trans } from "@lingui/macro";
import { Box, Container, Switch, Typography } from "@mui/material";
import { GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";
import {
  FancyIcon,
  WfHeader,
  WfIconWorkoutTypesBikingRoad,
  WfMenuList,
  WfMenuListItem,
} from "@WahooFitness/redesignr";
import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import useWorkoutRecommendations from "./useWorkoutRecommendations";

const systm = "SYSTM";
const wahooApp = "Wahoo App";
const wahoo = "Wahoo";
function WorkoutRecommendations() {
  const { isCyclingToggled, handleToggle } = useWorkoutRecommendations();

  return (
    <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
      <GlobalHeader />

      <Box display="flex" flexDirection="column" p={2} gap={0.5}>
        <Typography variant="ui-lg-bold">
          <Trans>Workout recommendations</Trans>
        </Typography>
        <Typography variant="prose-sm">
          <Trans>
            Workout recommendations suggest the best activity for you each day and update after
            every workout based on your load and recovery needs.
          </Trans>
        </Typography>
      </Box>
      <WfHeader
        title={t`Enable for:`}
        hierarchy="H3"
        data-testid="settingsHeader"
        description={t`The recommended workout will be shown on your home page in both ${systm} and the ${wahooApp}.`}
      />
      <WfMenuList>
        <WfMenuListItem
          id="cycling-toggle"
          content={t`Cycling training`}
          startIcon={
            <FancyIcon size="small" color="info" icon={<WfIconWorkoutTypesBikingRoad />} />
          }
          data-testid="workoutRecommendations.cyclingProfile"
          secondaryContent={t`Daily ${wahoo} structured workouts to improve cycling performance.`}
          primaryRightComponentOverride={
            <Switch
              color="info"
              checked={isCyclingToggled}
              onChange={handleToggle}
              name={String(WahooWorkoutTypeFamily.Cycling)}
            />
          }
        />
      </WfMenuList>
    </Container>
  );
}

export default WorkoutRecommendations;
